import { render } from "./CatalogSelectorRedesigned.vue?vue&type=template&id=62ccf5c6&scoped=true"
import script from "./CatalogSelectorRedesigned.vue?vue&type=script&lang=js"
export * from "./CatalogSelectorRedesigned.vue?vue&type=script&lang=js"

import "./CatalogSelectorRedesigned.vue?vue&type=style&index=0&id=62ccf5c6&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ccf5c6"]])

export default __exports__